import { useCallback, useEffect, useMemo, useRef } from 'react';
import { resetState as resetMapState } from '@alltrails/maps/redux/reducer';
import { useAppDispatch, useAppSelector } from '@/utils/redux';
import { setIsTrailMapOpen } from '@/utils/trailPageSlice';

export default function useIsTrailMapOpen() {
  const dispatch = useAppDispatch();
  const isTrailMapOpen = useAppSelector(state => state.trailPage.isTrailMapOpen);

  const wasTrailMapOpen = useRef(isTrailMapOpen);

  useEffect(() => {
    if (isTrailMapOpen) {
      wasTrailMapOpen.current = true;
    } else if (wasTrailMapOpen.current) {
      dispatch(resetMapState({ resetStyleKeys: true }));
    }
  }, [dispatch, isTrailMapOpen]);

  useEffect(() => {
    return () => {
      // When a component calling this hook is unmounted, close the trail map
      dispatch(setIsTrailMapOpen(false));
    };
  }, [dispatch]);

  const openTrailMap = useCallback(() => {
    dispatch(setIsTrailMapOpen(true));
  }, [dispatch]);

  return useMemo(() => ({ isTrailMapOpen, openTrailMap }), [isTrailMapOpen, openTrailMap]);
}
